import tw, { styled } from 'twin.macro';
import { keyframes, css } from '@emotion/react';

const fplsBlue = '#00a0c6';

export const PrevNextWrapper = styled.div`
  ${tw`mt-3`}
  text-align: var(--nextprev-align)
`;

export const PrevNextButton = styled.button`
  ${tw`bg-grey-light cursor-pointer py-3 px-4 mx-0.5 text-center outline-none 
    text-white rounded-3xl border-0
  `}
  box-shadow: rgb(0 0 0 / 14%) 0 0 4px 0, rgb(0 0 0 / 28%) 0 4px 8px 0;
  color: var(--btn-color, #fff);
  background-color: var(--btn-bg, #333447);
  border-radius: var(--btn-radius);
  font-family: var(--font-family) !important;
`;

export const BtnWrapper = styled.div`
  ${tw`flex w-full flex-wrap`}
  justify-content:var(--btn-align);
  gap: 1rem;
  direction: initial;

  @media screen and (max-width: 425px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const SubmitButton = styled.button`
  ${tw`min-w-20 border-0 outline-none text-center 
    inline-block py-4 px-6 cursor-pointer`};
  box-shadow: rgb(0 0 0 / 14%) 0 0 4px 0, rgb(0 0 0 / 28%) 0 4px 8px 0;

  ${({ submitInProgress }) =>
    submitInProgress &&
    `
    display: flex;
    justify-content: center;
    align-items: center;
  `};

  color: var(--btn-color, #fff);
  background-color: var(--btn-bag, #00afbf);
  border-radius: var(--btn-radius);
  font-size: 17px;
  font-family: var(--font-family) !important;
  transition: all 0.3s ease-in-out;

  :hover {
    filter: brightness(0.85);
  }

  &#disable {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const SaveAndContinueButton = styled.button`
  ${tw`min-w-20 outline-none flex items-center border-0 justify-center text-center py-4 px-6 cursor-pointer`};
  color: var(--btn-color, #555);
  background-color: var(--btn-bag, #e0e0e0);
  border-radius: var(--btn-radius);
  font-family: var(--font-family) !important;
  transition: all 0.3s ease-in-out;
  box-shadow: rgb(0 0 0 / 14%) 0 0 4px 0, rgb(0 0 0 / 28%) 0 4px 8px 0;

  font-size: 17px;
  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
    opacity: 0.5;
  `};

  :hover {
    filter: brightness(0.85);
  }
`;

export const SaveFormModalContent = styled.div`
  margin: auto;
  width: 100%;
  height: 352px;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;

  & .modal-header {
    width: 100%;
    height: 100%;
    flex: 0 0 25%;
    background: linear-gradient(270deg, #00afbf, #1a8caf);
    display: flex;
    align-items: center;
    justify-content: center;

    & h3 {
      color: white;
      font-size: 22px;
      font-weight: 500;
      font-family: var(--font-family) !important;
    }
  }

  & .modal-body {
    width: 100%;
    height: 100%;
    flex: 0 0 75%;
    background-color: #fff;
    padding-inline: 3rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: space-evenly;
    font-family: var(--font-family) !important;

    & .modal-buttons-container {
      display: flex;
      justify-content: flex-end;
      gap: 1.5rem;

      & input[type='submit'] {
        height: 35px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        color: #fff;
        border: 0.5px solid ${fplsBlue};
        background-color: ${fplsBlue};
        width: 127px;
        font-family: var(--font-family) !important;
        transition: 0.3s;

        :hover {
          filter: brightness(0.85);
        }
      }
    }

    & p {
      font-size: 16px;
      font-weight: 450;
    }

    & .email-info {
      > p {
        font-family: var(--font-family) !important;

        &.payment-error {
          ${tw`text-yellow-500`}
        }
      }
      & > input {
        background-color: #f2f6fd;
        font-family: var(--font-family) !important;
      }
    }
  }
`;

export const SavedFormModalContent = styled.div`
  margin: auto;
  width: 100%;
  height: 460px;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;

  & .modal-header {
    width: 100%;
    height: 100%;
    flex: 0 0 25%;
    background-color: ${fplsBlue};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .modal-body {
    width: 100%;
    height: 100%;
    flex: 0 0 75%;
    background-color: #fff;
    padding: 2rem 3rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: flex-end;
    position: relative;

    & .modal-subheader {
      display: flex;
      flex-direction: column;
      align-items: center;

      & h3 {
        color: #007996;
        font-size: 22px;
        font-weight: 500;
        font-family: var(--font-family) !important;
      }

      & p {
        color: #252525;
        font-size: 16px;
        font-weight: 300;
        font-family: var(--font-family) !important;
      }
    }

    & .link-img {
      height: 138px;
      width: 134px;
      position: absolute;
      inset: 0;
      top: -65px;
    }

    & .modal-input-container {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      & .modal-input {
        position: relative;
        width: 100%;

        & > input {
          background-color: #f2f6fd;
          font-family: var(--font-family) !important;
        }
      }

      i {
        padding-inline: 1rem 0;
        font-weight: 500;
        font-size: 12px;
        font-family: var(--font-family) !important;
      }
    }

    & .modal-buttons-container {
      display: flex;
      justify-content: flex-end;
      gap: 1rem;

      > button {
        font-family: var(--font-family) !important;
      }
    }
  }
`;

export const ModalButton = styled.button`
  height: 35px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  font-family: var(--font-family) !important;
  transition: 0.3s;

  &.cancel {
    width: 143px;
    color: #fc260a;
    border: 0.5px solid #fc260a;
    background-color: #fff;

    :hover {
      background-color: brown;
      color: #fff;
    }
  }

  &.close {
    width: 133px;
    color: #fff;
    border: 0.5px solid ${fplsBlue};
    background-color: ${fplsBlue};

    :hover {
      filter: brightness(0.85);
    }
  }
`;

export const CopyButton = styled.button`
  position: absolute;
  right: 3px;
  top: 3px;
  bottom: 3px;
  // width: 7rem;
  height: auto;
  border: 0;
  background-color: ${({ isCopied }) => (isCopied ? '#e6e6e6' : '#eee')};
  border-radius: 3px;
  color: #3f3e3e;
  outline: none;
  margin: 0;
  padding: 0 10px;
  z-index: 3;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  font-size: 14px;
  font-weight: 450;
  cursor: pointer;
  font-family: var(--font-family) !important;
  transition: 0.3s;

  img {
    height: 15px;
    width: 15px;
  }

  :hover {
    background-color: #e6e6e6;
  }
`;

export const PostSubmissionText = styled.h1`
  font-weight: 300;
  font-size: 45px;
  word-break: break-word;
  color: #00afbf;
  margin: 0;
  text-align: center;

  @media screen and (min-width: 768px) {
    font-size: 68px;
  }
`;

export const SubmissionText = styled.div`
  font-size: 18px;
  color: #303030;
  font-family: var(--font-family) !important;
  ${({ submitting }) => submitting && `color: #fff;`}
  ${({ redirect }) =>
    redirect &&
    `
    font-weight: 500;
    font-size: 16px !important;
    text-align: center;
    & > :nth-of-type(n){
    text-decoration: underline;
    cursor: pointer;
    }
    & > .redirect-link{
    color: #00afbf;
    }
    & > .cancel-redirect{
      color: #ed4c5c;
    }`}
    ${({ main }) =>
    main &&
    `
      text-align: var(--text-align);
      direction: var(--direction);
    }
    `};
  ${({ submitted }) =>
    submitted &&
    `
      text-align: center;
      
      & > span {
      color: #00afbf;
      text-decoration: underline;
      cursor: pointer;
    }
  `};

  .pre-wrap {
    white-space: pre-wrap;
    font-size: inherit !important;
    font-family: inherit !important;

    h1,
    h2,
    h3,
    h4,
    h5,
    strong {
      font-family: inherit !important;
    }

    a {
      color: #4183c4;
      opacity: 0.9;
      text-decoration: underline;

      :hover {
        opacity: 1;
      }
    }

    ol, ul {
      display: block;
      list-style-position: inside;
    }

    iframe {
      border: none;
      max-width: 100%;
    }
  }

  @media screen and (min-width: 768px) {
    font-size: 18px;
  }
`;

export const CreateFormText = styled.p`
  font-size: 16px;
  font-family: var(--font-family) !important;
  color: #525252;
  margin: 0;
  padding-top: 50px;
  text-align: center;

  & > span {
    font-weight: bolder;
    font-family: inherit !important;
  }
`;

export const SubmissionMessage = styled.div`
  width: 100%;
  min-height: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 6px;
  padding-inline: 1.5rem;
  ${({ error }) =>
    error &&
    `
    background-color: #fff1f1;
    color: brown;
    border: 0.2px solid brown;
  `}
  ${({ upload }) =>
    upload &&
    `
    color: rgba(0, 0, 0, .87);
    background-color: #f8f8f9;
    -webkit-box-shadow: 0 0 0 1px rgba(34, 36, 38, .22) inset, 0 0 0 0 transparent;
    box-shadow: 0 0 0 1px rgba(34, 36, 38, .22) inset, 0 0 0 0 transparent;
    & > h5 {
      margin: 0;
    }
  `}

  & h5 {
    font-weight: 700;
    font-size: 16px;
    margin: 0;
    font-family: var(--font-family) !important;
  }

  & p {
    font-weight: 400;
    font-size: 14px;
  }
`;

export const ButtonsContainer = styled.div`
  display: grid;
  gap: 2rem;
`;

export const MainContainer = styled.div`
  padding-inline: 23.1px;
  font-family: var(--font-family) !important;
`;

export const PostSubmissionFormContainer = styled.div`
  position: fixed;
  z-index: 9999;
  inset: 0;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  background-color: white;
  ${({ error }) =>
    error &&
    `
    z-index: 9980;
    display: grid;
    place-items: center;
    height: 100vh;
  `};
  ${({ formPageStyles }) => formPageStyles};

  padding-bottom: 50px !important;
`;

export const SubmittedFormContainer = styled.div`
  max-width: 90%;
  // height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;
  ${({ underline }) => underline && `border-bottom: 0.5px solid #00000050`};
  padding: 5rem 0 3rem 0;
  z-index: 2;
  ${({ none }) => none && `flex: 0 0 50%;`};
  ${({ more }) => more && `flex: 0 0 45%;`};

  @media screen and (min-width: 768px) {
    max-width: 65%;
  }
`;

export const CreateFormContainer = styled.div`
  flex: 0 0 45%;
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: flex-start;
  padding-top: 2rem;
  z-index: 2;
`;

export const EditFormContainer = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  z-index: 2;

  .edit-another-print,
  .create-form {
    width: 80%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;

    @media screen and (max-width: 465px) {
      width: 100%;
    }
  }

  .create-form > a {
    font-weight: 500;
    font-size: 14px;
    font-weight: bolder;
    color: #00afbf;
    text-decoration: underline;
    cursor: pointer;
    font-family: var(--font-family) !important;
  }

  @media screen and (min-width: 768px) {
    width: 70%;
  }
`;

export const EditResponseInput = styled.div`
  position: relative;
  font-family: var(--font-family) !important;
  width: 100%;

  & > input {
    background-color: #f2f6fd;
    font-family: var(--font-family) !important;
  }
`;

export const CopyContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: auto;
  height: auto;
  color: #00afbf;
  padding: 0 10px;
  z-index: 3;
  font-size: 12px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  background-color: ${({ isCopied }) => (isCopied ? '#eee' : '#f2f6fd')};
  border-radius: inherit;
  transition: 0.3s;

  img {
    height: 15px;
    width: 15px;
  }

  > span {
    font-family: inherit !important;
    @media screen and (max-width: 430px) {
      display: none;
    }
  }

  :hover {
    background-color: #eee;
  }
`;

export const DefaultButton = styled.button`
  width: 253px;
  height: 45px;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  font-family: var(--font-family) !important;
  background: linear-gradient(270deg, #1a8caf -18.55%, #00afc4 60.48%);
  cursor: pointer;
  border-radius: 3px;
  border: none;
  outline: none;
  padding: 0;

  > a {
    ${tw`flex items-center justify-center text-white`}
    width: 100%;
    height: 100%;
    text-decoration: none;
  }

  @media screen and (max-width: 465px) {
    width: 100%;
  }
`;

export const LoadingContainer = styled.div`
  position: fixed;
  z-index: 5;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  background-color: #00000090;
`;

export const LoaderAndMessageContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;
`;

export const SubmitAnotherAndPrint = styled.div`
  width: 100%;
  display: flex;
  ${({ both }) => both && ` flex-direction: column;`}
  gap: 1rem;
  justify-content: center;
  gap & > :nth-of-type(n) {
    flex: 0 0 50%;
  }

  @media screen and (min-width: 768px) {
    ${({ both }) => both && ` flex-direction: row;`}
  }
`;

export const SubmitAnotherAndPrintButton = styled.button`
  min-height: 45px;
  height: fit-content;
  color: ${fplsBlue};
  font-weight: 500;
  font-size: 16px;
  font-family: var(--font-family) !important;
  background: #fff;
  cursor: pointer;
  border-radius: 3px;
  border: 0.5px solid ${fplsBlue};
  outline: none;
  padding: 0 10px;
  transition: 200ms;

  ${({ both }) => both && `width: -webkit-fill-available;`}
  ${({ single }) => single && `width: 360px;`}

  &:hover {
    background: linear-gradient(270deg, #1a8caf -18.55%, #00afc4 60.48%);
    color: #fff;
  }
`;

const partialSubFlashLoading = keyframes`
0%, 25% { background-color: #00000060; transform: scale(1.13, 1.33) }
26%, 100% {background-color: #71c6da; transform: scale(1, 1)}
`;

const fulSubFlashLoading = keyframes`
0%, 25% { background-color: #fff; transform: scale(1.13, 1.33) }
26%, 100% {background-color: #71c6da; transform: scale(1, 1)}
`;

export const LoadingLines = styled.span`
  width: 1.6rem;
  height: 1.8rem;
  border-radius: 5px;
  background-color: #c4c4c450;
  ${({ partialSub }) =>
    partialSub &&
    css`
      animation: ${partialSubFlashLoading} 2s infinite linear;
    `}
  ${({ fullSub }) =>
    fullSub &&
    css`
      animation: ${fulSubFlashLoading} 2s infinite linear;
    `}

  &:nth-of-type(1) {
    animation-delay: 0.5s;
  }

  &:nth-of-type(2) {
    animation-delay: 1s;
  }

  &:nth-of-type(3) {
    animation-delay: 1.5s;
  }

  &:nth-of-type(4) {
    animation-delay: 2s;
  }
`;

export const GreenLeafImg = styled.img`
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 160px;
  height: 210px;
  z-index: 1;
`;

export const OrangeLeafImg = styled.img`
  position: fixed;
  top: 0px;
  right: 0px;
  width: 160px;
  height: 210px;
  z-index: 1;
`;

export const ButtonLoading = styled.div`
  font-size: 5px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: loading 1.1s infinite linear;
  animation: loading 1.1s infinite linear;
  ${({ submit }) =>
    submit &&
    `border-top: 0.5em solid rgba(255, 255, 255, 0.2);
  border-right: 0.5em solid rgba(255, 255, 255, 0.2);
  border-bottom: 0.5em solid rgba(255, 255, 255, 0.2);
  border-left: 0.5em solid #ffffff;`}
  ${({ saveAndContinue }) =>
    saveAndContinue &&
    `border-top: 0.5em solid #00afbf20;
  border-right: 0.5em solid #00afbf20;
  border-bottom: 0.5em solid #00afbf20;
  border-left: 0.5em solid #00afbf;`}
  &,
  &:after {
    border-radius: 50%;
    width: 15px;
    height: 15px;
  }
  @-webkit-keyframes loading {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes loading {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

export const PrintPreview = styled.section`
  width: 80%;
  padding: 3rem 1rem;
  z-index: 3;
  font-family: var(--font-family) !important;

  @media print {
    #no_print {
      display: none;
    }
  }

  @media screen and (min-width: 768px) {
    width: 75%;
  }
`;

export const PrintActions = styled.div`
  text-align: right;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  position: sticky;
  top: 20px;

  > button {
    font-family: var(--font-family) !important;
    background-color: #fff;
    outline: none;
    border: 1px solid ${fplsBlue};
    color: ${fplsBlue};
    border-radius: 2px;
    padding: 5px 15px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    :hover {
      background-color: #eee;
    }

    &#print {
      background-color: ${fplsBlue};
      color: white;

      :hover {
        filter: brightness(0.8);
      }
    }
  }
`;

export const ResponsesPreview = styled.div`
  margin: 2rem 0;

  > h2 {
    ${tw`text-center mb-12`}
    font-family: var(--font-family) !important;
  }

  > ol {
    ${tw`m-0 p-0`}

    li {
      ${tw`mx-0 my-8 `}

      > p {
        ${tw`m-0 p-0 font-bold`}
      }

      > div {
        ${tw`m-0 p-0 overflow-auto`}

        table > th,td {
          font-family: var(--font-family) !important;
        }
      }
    }
  }
`;

export const InvalidEmailError = styled.small`
  color: red;
  margin-top: 10px;
`;